<div
  class="h-full rounded-xl border border-gray-100 bg-white shadow-sm"
  [attr.aria-busy]="loading"
>
  <div class="border-b border-gray-100 px-5 py-4">
    <h3 id="pending-foc-chart-title" class="font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
      Pending FOC Date
      <span class="ml-1 font-normal normal-case text-brand-muted">({{ total || '…' }})</span>
    </h3>
  </div>

  @if (loading) {
    <div class="flex items-center justify-center py-16" role="status" aria-label="Loading Pending FOC Date chart">
      <mat-spinner [diameter]="50" aria-hidden="true"></mat-spinner>
    </div>
  } @else {
    <figure class="m-0 px-4 py-2">
      <p id="pending-foc-chart-desc" class="sr-only">
        Pending FOC Date bar chart with {{ data.length }}
        {{ data.length === 1 ? 'bar' : 'bars' }}. The data table lists each
        label and order count.
      </p>
      <canvas
        baseChart
        id="pending-foc-chart"
        role="img"
        aria-label="Bar chart: Pending FOC Date"
        aria-describedby="pending-foc-chart-desc"
        height="220px"
        [data]="barChartData"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [type]="barChartType"
      ></canvas>

      <figcaption class="sr-only">
        <h4 id="pending-foc-chart-table-title">Pending FOC Date data table</h4>
        <table aria-labelledby="pending-foc-chart-table-title">
          <caption>
            Pending FOC Date data points
          </caption>
          <thead>
            <tr>
              <th scope="col">Label</th>
              <th scope="col">Orders</th>
            </tr>
          </thead>
          <tbody>
            @for (item of data; track item.label) {
              <tr>
                <th scope="row">{{ item.label }}</th>
                <td>{{ item.value }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="2">No chart data available</td>
              </tr>
            }
          </tbody>
        </table>
      </figcaption>
    </figure>
  }
</div>
